wp.domReady(function() {
    wp.blocks.registerBlockStyle('core/group', {
        name: 'full-width',
        label: 'Full Width'
    });

    wp.blocks.registerBlockStyle('core/group', {
        name: 'three-quarters-width',
        label: '3/4'
    });

    wp.blocks.registerBlockStyle('core/cover', {
        name: 'full-width',
        label: 'Full Width'
    });

    wp.blocks.registerBlockStyle('core/image', {
        name: 'full-width',
        label: 'Full Width'
    });

    wp.blocks.registerBlockStyle('core/paragraph', {
        name: 'eyebrow',
        label: 'Eyebrow Text'
    });
});